import { useEffect } from 'react';

const STYLE_ID = 'comfy-cta';

// Flat, sharp-cornered filled CTA — the canonical button used by the
// FloorplansList "View All Layouts" call to action. Solid secondary fill that
// swaps to the primary color on hover (a clean color-swap, no sheen / lift /
// rounded corners). Colors are overridable via CSS custom properties so a
// section that already sits ON the secondary color (e.g. NeighborhoodSection)
// can flip the fill to something that stays legible against its background.
const COMFY_CTA_CSS = `
.comfy-cta {
  display: inline-block;
  max-width: 100%;
  padding: 1rem 3rem;
  font-family: var(--vibe-font-body), sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  background: var(--comfy-cta-bg, var(--vibe-color-secondary));
  color: var(--comfy-cta-fg, var(--vibe-color-text-on-secondary));
  transition: background-color 0.3s ease, color 0.3s ease;
}
.comfy-cta:hover {
  background: var(--comfy-cta-bg-hover, var(--vibe-color-primary));
  color: var(--comfy-cta-fg-hover, var(--vibe-color-text-on-primary));
}
`;

/**
 * Injects the flat "Comfy" CTA button CSS into <head> exactly once.
 * Pair with the `comfy-cta` class on the anchor/button. Override the resting or
 * hover colors on a parent/element via the `--comfy-cta-bg`,
 * `--comfy-cta-fg`, `--comfy-cta-bg-hover`, and `--comfy-cta-fg-hover`
 * custom properties when the default secondary→primary swap would clash with
 * the surrounding surface.
 */
export function useComfyCtaStyles(): void {
  useEffect(() => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = COMFY_CTA_CSS;
    document.head.appendChild(style);
  }, []);
}
